<template>
    <div
        class="metrics-configuration-category-grid"
        data-testid="metrics-configuration-category-grid"
        :class="{ showHeader }"
    >
        <div
            class="flex-row"
            v-if="showHeader"
        >
            <h2 data-testid="name">
                {{ headerName }}
            </h2>
            <InformationTooltip v-if="headerName === 'Schedule Metrics'">
                <template #tooltip>
                    Schedule Metrics give you a breakdown of the time an agent has been scheduled to work / has
                    actually worked on specific tasks within their shifts.<br>
                </template>
                <template #icon>
                    <al-icon
                        icon="info-inverted"
                        variant="secondary"
                    />
                </template>
            </InformationTooltip>
            <InformationTooltip v-if="headerName === 'Interaction Metrics'">
                <template #tooltip>
                    Interaction Metrics give you a breakdown of the work effort a user has spent providing service
                    through specific channels such as phone, chat, ticket and email.<br>
                </template>
                <template #icon>
                    <al-icon
                        icon="info-inverted"
                        variant="secondary"
                    />
                </template>
            </InformationTooltip>
        </div>
        <div
            class="card-grid"
            data-testid="card-grid-container"
        >
            <div
                v-for="(subcategory, idx) in children"
                :key="idx"
            >
                <SubcategoryCard
                    v-bind="subcategory"
                    :is-active="!!selectedChild && selectedChild.headerName === subcategory.headerName"
                    @click="setSelectedChild(idx)"
                />
            </div>
        </div>
        <div
            v-if="selectedChild"
            data-testid="data-grid-container"
        >
            <DataGrid
                v-bind="selectedChild"
                :close="setSelectedChild"
                @update-children="handleUpdatedChildren"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import {
    DataGrid, InformationTooltip, SubcategoryCard
} from '@/components';
import { MetricsConfigColumnDefinition } from '@agyletime/performance-utils';
import {
    defineProps, ref, withDefaults
} from 'vue';

interface Props {
    // eslint-disable-next-line vue/require-default-prop
    headerName?: string;
    children: MetricsConfigColumnDefinition[];
    showHeader: boolean;
}
const props = withDefaults(defineProps<Props>(), { showHeader: true });
const selectedChild = ref<null | MetricsConfigColumnDefinition>(null);

const setSelectedChild = (key?: number) => {
    selectedChild.value = typeof key === 'number' ? props.children[key] : null;
};

const handleUpdatedChildren = (children: MetricsConfigColumnDefinition[]) => {
    if (selectedChild.value) {
        selectedChild.value.children = children;
    }
};
</script>
<style lang="scss">
@import './style.scss';
</style>
